import styled from 'styled-components'
import { APP_HEADER_FIXED_HEIGHT } from '../AppHeader/styles'

export const SummaryPreview = styled.div<{
  bundleHasAnyDiscount?: boolean
  isExpanded?: boolean
}>`
  flex-grow: 1;
  margin-right: 5px;
  display: flex;
  justify-content: flex-end;

  @media (min-width: 768px) {
    margin-right: 10px;
  }

  @media (min-width: 1200px) {
    position: relative;
  }

  .expand-collapse-btn {
    background: none;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    gap: 10px;

    @media (hover: hover) {
      &:hover {
        color: ${(props) => props.theme.palette.primary.main};
      }
    }

    .price {
      font-size: 18px;
      font-weight: 500 !important; // Due to Scensum CSS
      ${(props) => !props.bundleHasAnyDiscount && `color: ${props.theme.palette.basic.dark};`}

      @media (max-width: 400px) {
        font-size: 16px;
      }

      @media (min-width: 1200px) {
        font-size: 23px;
      }

      &.is-high-amount {
        @media (max-width: 400px) {
          font-size: 14px;
        }
      }
    }

    i {
      font-size: 20px;
      transform: translateY(2px);

      @media (min-width: 1200px) {
        transform: translateY(3px);
        font-size: 23px;
      }
    }
  }

  .expanded-info-container {
    display: flex;
    position: absolute;
    top: ${APP_HEADER_FIXED_HEIGHT};
    left: 0;
    z-index: 3;
    width: 100vw;
    height: calc(100dvh - ${APP_HEADER_FIXED_HEIGHT});
    flex-direction: column;
    gap: 30px;
    padding: 15px 15px 30px;
    overflow-y: auto;
    background-color: #ffffff;
    opacity: ${(props) => (props.isExpanded ? '1' : '0')};
    transform: translateY(${(props) => (props.isExpanded ? '0' : '-10px')});
    visibility: ${(props) => (props.isExpanded ? 'visible' : 'hidden')};
    pointer-events: ${(props) => (props.isExpanded ? 'auto' : 'none')};
    transition:
      opacity 0.2s ease-in-out,
      transform 0.2s ease-in-out,
      visibility 0s ${(props) => (props.isExpanded ? '0s' : '0.2s')};

    @media (min-width: 768px) {
      padding: 30px;
    }

    @media (min-width: 1200px) {
      top: calc(${APP_HEADER_FIXED_HEIGHT} / 2 + 50%);
      left: calc(100% - 500px + 15px);
      width: 500px;
      height: 75vh;
    }
  }
`

export const CampaignAndPriceWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
`
